/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit WelcomeScreen/view.blocks to change it.
import ButtonIconSquare from 'DesignSystem/ButtonIconSquare/index'
import Initialstepgraphic01 from 'DesignSystem/Svgs/Initialstepgraphic01/index'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsHovered from 'Simple/hooks/useIsHovered'
import { animated, useSpring } from "@react-spring/web"



/** @type {import('Simple/types.js').View} */
export default function WelcomeScreen({
  children,
  viewPath = "/App/WelcomeScreen",
  onClick
  
}) {
  let isBefore = useIsBefore()
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let animatedVertical10 = useSpring({
"config": {
tension: 180,
friction: 12,
},
"delay": 250,
"from": {"scale": 1},
"to": {"scale": isBefore ? 0.75 : 1},
})
  return (<React.Fragment
>
<div
  data-testid="WelcomeScreen.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--o-1-1ICf6y': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<animated.div
  data-testid="WelcomeScreen.Vertical:1"
  data-view-path={viewPath}
 style={{"--s-2-1ICf6y": animatedVertical10.scale,}}
 className={`views-block ${styles.Vertical1}`}
>
<ButtonIconSquare
  viewPath={`${viewPath}/ButtonIconSquare`}
 marginTopText={40}
 text="Schedule New Patient Appointment"
 width={340}
 height={340}
>
{childProps => (
<Initialstepgraphic01
{...childProps}
  viewPath={`${viewPath}/Initialstepgraphic01`}
 height={200}
 width={360}
/>
)}
</ButtonIconSquare>
</animated.div>
</div>
{children}
</React.Fragment>)
}